import Bury from '@/common/bury.js';

export default {
  inserted(el, binding) {
    //按钮点击执行事件
    const handleClick = (el, binding) => {
      console.log(binding);
      //修饰符
      //   const idFlag = binding.modifiers.idFlag ? 1 : 0;
      //绑定值
      const data = binding.value;
      //埋点外部传参对象
      Bury.buryAdd(data, el);
    };
    const wrappedClickEvent = function(event) {
      handleClick(el, binding, event);
    };
    el.addEventListener('click', debounce(wrappedClickEvent, 300));
    el.handleClick = handleClick;
  },
  unbind(el, binding) {
    const handleClick = el.handleClick;
    el.removeEventListener('click', handleClick);
    delete el.handleClick;
  }
};

// 防抖
function debounce(fn, delay = 500) {
  var timer = null;
  return function() {
    var _this = this;
    var args = arguments;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(_this, args);
    }, delay);
  };
}
